import React from "react";
import cx from "classnames";
import { makeAutocompleteServerSource } from "./autocompleteApi.js";

export default function Autocomplete({
  name,
  label,
  placeholder = "",
  required = false,
  fullWidth = true,
  extraClass = "",
  error = false,
  errorMsg = "This field is required",
  helperText,
  defaultValue = "",
  dataKey,
  disabled = false,
}) {
  const classes = cx("sc-form-item autocomplete js-autocomplete", {
    "js-form-required": required,
    "sc-form-item--optional": !required,
    "sc-form-item--full-width": fullWidth,
    "has-error": error,
  });

  const fetchItems = async event => {
    const query = event.target.value;
    const serverSource = makeAutocompleteServerSource();
    const items = await serverSource(query);
  };

  return (
    <label
      className={classes}
      data-name={name}
      data-required={required}
      data-key={dataKey}
    >
      {label && <span className="sc-form-item__label">{label}</span>}

      <input
        className={cx(`sc-form-item__field ${extraClass}`, {
          "input-validation-error": error,
        })}
        type="text"
        role="combobox"
        aria-autocomplete="list"
        aria-expanded="false"
        autoComplete="off"
        placeholder={placeholder}
        defaultValue={defaultValue}
        disabled={disabled}
        onKeyUp={e => fetchItems(e)}
      />

      <ul className="autocomplete__menu" role="listbox" hidden></ul>

      <span role="alert" className="sc-form-item__error-msg">
        {errorMsg}
      </span>

      {helperText && (
        <div className="sc-form-item__helper-text">
          <span>{helperText}</span>
        </div>
      )}
    </label>
  );
}
